var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAppStoreLogo = function SvgIconAppStoreLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.11 4.258a1 1 0 1 0-1.721-1.017L12 5.591l-1.39-2.35a1 1 0 1 0-1.72 1.018l1.95 3.299L6.59 14.75H2.25a1 1 0 1 0 0 2h10.238a1 1 0 1 0 0-2H8.914z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.41 14.75-2.374-4.018a1 1 0 1 0-1.722 1.017l2.632 4.453q.028.057.065.11l2.628 4.447a1 1 0 1 0 1.722-1.018l-1.768-2.991h3.157a1 1 0 1 0 0-2zM5.803 20.007a1 1 0 0 0-1.725-1.014l-.44.75a1 1 0 1 0 1.724 1.014z"
  }))));
};
export default SvgIconAppStoreLogo;